import FetchPromise from '~/agent/fetch-promise';
import { useDefaultMutation } from '~/lib/react-query';

export interface UpdateSourceDocumentParams {
  id: string;
  signedId: string;
  isUploaded: boolean;
}

export function updateSourceDocument(params: UpdateSourceDocumentParams): Promise<void> {
  return FetchPromise.put(`source_documents/${params.id}`, {
    complete_upload: params.isUploaded,
    signed_id: params.signedId,
  });
}

export function useUpdateSourceDocumentMutation() {
  return useDefaultMutation(updateSourceDocument);
}
